<template>
  <div
    v-if="cdata.length"
    class="left-top"
    style="transform-origin: 0px 0px;height: 260px; width: 484px"
    :style="`transform: scale(${sscale})`"
  >
    <v-chart :forceFit="true" :height="height" :data="cdata" :padding="padding">
      <!-- <v-coord type="rect" /> -->
      <v-tooltip />
      <!-- <v-legend /> -->
      <v-axis dataKey="count" position="left" :label="label2" />
      <v-axis dataKey="item" :label="label" />
      <v-bar position="item*count" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  props: {
    physical: {
      default() {
        return []
      },
    },
  },
  mounted() {
    this.sscale = window.innerWidth / 1920

    const data = this.physical

    // console.log(data);

    const dv = new DataSet.View().source(data)
    dv.transform({
      type: 'sort',
      callback(a, b) {
        return a.count - b.count > 0
      },
    })
    const cdata = dv.rows

    const scale = [
      {
        dataKey: 'count',
        tickInterval: 20,
      },
    ]

    const label = {
      offset: 12,
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const label2 = {
      textStyle: {
        fill: '#82A9EF',
      },
    }

    // const adjust = [{ type: 'dodge', marginRatio: 1 / 32 }]
    // this.adjust = adjust
    this.scale = scale
    this.label = label
    this.label2 = label2
    this.cdata = cdata
  },
  data() {
    return {
      sscale: 1,
      scale: [],
      cdata: [],
      height: 255,
      label: [],
      label2: [],
      adjust: [],
      padding: [10, 40, 60, 40],
    }
  },
}
</script>

<style lang="less" scoped>
.left-top {
  padding: 0 15px;
  margin-top: 36px;
}
</style>
